// ─── TRANSLATIONS ─────────────────────────────────────────────────────────────
const T = {
  en: {
    appName: 'Sedra Home Wholesale',
    login: 'Admin Login', password: 'Password', signIn: 'Sign In',
    wrongPassword: 'Incorrect password', logout: 'Logout',
    dashboard: 'Dashboard', products: 'Products', customers: 'Customers',
    orders: 'Orders', settings: 'Settings',
    totalProducts: 'Total Products', totalCustomers: 'Total Customers',
    totalOrders: 'Total Orders', newOrders: 'New Orders',
    addProduct: 'Add Product', editProduct: 'Edit Product', deleteProduct: 'Delete Product',
    importCSV: 'Import CSV', downloadTemplate: 'Download Template',
    nameEn: 'Name (English)', nameAr: 'Name (Arabic)', sku: 'SKU',
    category: 'Category', price: 'Price (EGP)', minQty: 'Min. Order Qty', cartonQty: 'Items per Carton',
    imageUrl: 'Image URL', save: 'Save', cancel: 'Cancel', delete: 'Delete',
    addCustomer: 'Add Customer', businessName: 'Business Name',
    contactName: 'Contact Name', phone: 'Phone', whatsapp: 'WhatsApp',
    email: 'Email', address: 'Address', notes: 'Notes',
    catalogueType: 'Catalogue Type', standard: 'Standard Wholesale',
    vatCatalogue: 'VAT Wholesale', noprice: 'Browse Only (No Price)',
    copyLink: 'Copy Link', preview: 'Preview',
    orderId: 'Order ID', date: 'Date', items: 'Items', total: 'Total',
    status: 'Status', markSeen: 'Mark Seen', exportCSV: 'Export CSV',
    webhookUrl: 'Google Sheets Webhook URL', testWebhook: 'Test Webhook',
    language: 'Language', saveSettings: 'Save Settings',
    catalogueLinks: 'Catalogue Links',
    standardLink: 'Standard (No VAT)', vatLink: 'VAT +14%', nopriceLink: 'No Price',
    noProducts: 'No products yet. Add your first product above.',
    noOrders: 'No orders yet.',
    noCustomers: 'No customers yet.',
    confirmDelete: 'Are you sure you want to delete this?',
    productSaved: 'Product saved!', productDeleted: 'Product deleted!',
    importSuccess: 'Products imported successfully!',
    settingsSaved: 'Settings saved!',
    loading: 'Loading...', error: 'Error loading data.',
    orderFrom: 'Order from', viewOrder: 'View Order',
    allCategories: 'All Categories', newArrivals: 'New Arrivals', addToCart: 'Add to Cart',
    myOrders: 'My Orders', syncSaved: 'Cart saved', syncSaving: 'Saving…',
    orderDate: 'Date', orderItems: 'Items', orderTotal: 'Total', orderStatus: 'Status',
    cart: 'Cart', checkout: 'Checkout', placeOrder: 'Place Order',
    orderSent: 'Order Sent!', orderThankYou: 'Thank you! Your order has been received.',
    orderRef: 'Order Reference', continueShopping: 'Continue Shopping',
    qty: 'Qty', subtotal: 'Subtotal', vatLabel: 'VAT (14%)',
    emptyCart: 'Your cart is empty.',
    requiredField: 'Required', new: 'New', seen: 'Seen',
    searchProducts: 'Search products...',
    adminPanel: 'Admin Panel',
    exportInvoice: 'Export Invoice', sendEmail: 'Send Email', sendWhatsApp: 'WhatsApp',
    autoSavedCustomer: 'Customer auto-saved from order', customerSource: 'Source',
    fromOrder: 'From order', manual: 'Manual', orderHistory: 'Order history', lastOrder: 'Last order',
    invoiceTitle: 'INVOICE', billTo: 'Bill To', orderDetails: 'Order Details',
    unitPrice: 'Unit Price', grandTotal: 'Grand Total',
    thankYou: 'Thank you for your business!',
  },
  ar: {
    appName: 'سدرة هوم — الجملة',
    login: 'دخول المدير', password: 'كلمة المرور', signIn: 'تسجيل الدخول',
    wrongPassword: 'كلمة المرور غير صحيحة', logout: 'تسجيل الخروج',
    dashboard: 'الرئيسية', products: 'المنتجات', customers: 'العملاء',
    orders: 'الطلبات', settings: 'الإعدادات',
    totalProducts: 'إجمالي المنتجات', totalCustomers: 'إجمالي العملاء',
    totalOrders: 'إجمالي الطلبات', newOrders: 'طلبات جديدة',
    addProduct: 'إضافة منتج', editProduct: 'تعديل المنتج', deleteProduct: 'حذف المنتج',
    importCSV: 'استيراد CSV', downloadTemplate: 'تحميل النموذج',
    nameEn: 'الاسم (إنجليزي)', nameAr: 'الاسم (عربي)', sku: 'كود المنتج',
    category: 'الفئة', price: 'السعر (ج.م)', minQty: 'الحد الأدنى للطلب', cartonQty: 'عدد القطع في الكرتونة',
    imageUrl: 'رابط الصورة', save: 'حفظ', cancel: 'إلغاء', delete: 'حذف',
    addCustomer: 'إضافة عميل', businessName: 'اسم المنشأة',
    contactName: 'اسم المسؤول', phone: 'الهاتف', whatsapp: 'واتساب',
    email: 'البريد الإلكتروني', address: 'العنوان', notes: 'ملاحظات',
    catalogueType: 'نوع الكتالوج', standard: 'جملة عادي',
    vatCatalogue: 'جملة + ضريبة', noprice: 'تصفح بدون أسعار',
    copyLink: 'نسخ الرابط', preview: 'معاينة',
    orderId: 'رقم الطلب', date: 'التاريخ', items: 'المنتجات', total: 'الإجمالي',
    status: 'الحالة', markSeen: 'تمييز كمقروء', exportCSV: 'تصدير CSV',
    webhookUrl: 'رابط Google Sheets', testWebhook: 'اختبار الرابط',
    language: 'اللغة', saveSettings: 'حفظ الإعدادات',
    catalogueLinks: 'روابط الكتالوجات',
    standardLink: 'عادي (بدون ضريبة)', vatLink: 'مع ضريبة +14%', nopriceLink: 'بدون أسعار',
    noProducts: 'لا توجد منتجات بعد. أضف أول منتج.',
    noOrders: 'لا توجد طلبات بعد.',
    noCustomers: 'لا يوجد عملاء بعد.',
    confirmDelete: 'هل أنت متأكد من الحذف؟',
    productSaved: 'تم حفظ المنتج!', productDeleted: 'تم حذف المنتج!',
    importSuccess: 'تم استيراد المنتجات بنجاح!',
    settingsSaved: 'تم حفظ الإعدادات!',
    loading: 'جاري التحميل...', error: 'خطأ في تحميل البيانات.',
    orderFrom: 'طلب من', viewOrder: 'عرض الطلب',
    allCategories: 'كل الفئات', newArrivals: 'وصل حديثاً', addToCart: 'أضف للسلة',
    myOrders: 'طلباتي', syncSaved: 'تم الحفظ', syncSaving: 'جاري الحفظ…',
    orderDate: 'التاريخ', orderItems: 'المنتجات', orderTotal: 'الإجمالي', orderStatus: 'الحالة',
    cart: 'السلة', checkout: 'إتمام الطلب', placeOrder: 'تأكيد الطلب',
    orderSent: 'تم إرسال الطلب!', orderThankYou: 'شكراً! تم استلام طلبك.',
    orderRef: 'رقم الطلب', continueShopping: 'مواصلة التسوق',
    qty: 'الكمية', subtotal: 'المجموع', vatLabel: 'ضريبة القيمة المضافة (14%)',
    emptyCart: 'سلتك فارغة.',
    requiredField: 'مطلوب', new: 'جديد', seen: 'مقروء',
    searchProducts: 'ابحث عن منتج...',
    adminPanel: 'لوحة التحكم',
    exportInvoice: 'تصدير الفاتورة', sendEmail: 'إرسال بريد', sendWhatsApp: 'واتساب',
    autoSavedCustomer: 'تم حفظ العميل تلقائياً من الطلب', customerSource: 'المصدر',
    fromOrder: 'من طلب', manual: 'يدوي', orderHistory: 'سجل الطلبات', lastOrder: 'آخر طلب',
    invoiceTitle: 'فاتورة', billTo: 'إلى', orderDetails: 'تفاصيل الطلب',
    unitPrice: 'سعر الوحدة', grandTotal: 'الإجمالي',
    thankYou: 'شكراً لتعاملكم فعنا!',
  }
};

export default T;
